export default "__VITE_ASSET__T5$$1TD0__"